import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import styled from 'styled-components'
import importer from '@takedapdt/biolife-core/src/importer'
const { devices } = importer('utils/styledComponentHelpers', null)
import Confetti from 'react-confetti'
import { ReactComponent as ButtonCloseIcon } from '../../../../assets/media/icons/button-close-large-white.svg'

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--color-rich-black);
  z-index: 1001;
  overflow: hidden;
`

const ModalContentWrapper = styled.div`
  position: absolute;
  top: 0;
  z-index: 1002;
  width: 100%;
  height: 100%;
  min-height: 100dvh;
  /* min-height: 100vh; */
  display: flex;
  align-items: center;
  justify-content: center;
`
const ModalContent = styled.div`
  position: relative;
  background: linear-gradient(to top, var(--color-dark-focus-blue) 10%, var(--color-dark-focus-blue) 45%, var(--color-light-blue) 85%);
  border-radius: 25px;
  width: 100%;
  height: 100%;
  max-width: ${({ $maxWidth }) => (typeof $maxWidth === 'number' ? `${$maxWidth}px` : $maxWidth || 'auto')};
  max-height: ${({ $maxHeight }) => (typeof $maxHeight === 'number' ? `${$maxHeight}px` : $maxHeight || 'auto')};
  overflow-y: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  ${devices.mobile} {
    width: '95vw';
    height: '100%';
    max-width: ${({ $maxWidthMobile }) => `${$maxWidthMobile}px` || 'auto'};
    max-height: ${({ $maxHeightMobile }) => `${$maxHeightMobile}px` || 'auto'};
    overflow-y: auto;
  }
`
const CloseModalIcon = styled.div`
  position: absolute;
  cursor: pointer;
  top: 16px;
  right: 16px;
  z-index: 7;
`

const StyledImage = styled(ButtonCloseIcon)`
  width: 32px;
  height: 32px;
  ${devices.mobile} {
    width: 28px;
    height: 28px;
  }
`

const GameCompleteModal = ({
  isOpen,
  onClose,
  children,
  maxWidth,
  maxWidthMobile,
  maxHeight,
  maxHeightMobile,
  isShowConfetti,
  hideCloseIcon = false
}) => {
  const modalRootStyles = {
    position: 'absolute',
    minHeight: '100dvh',
    // minHeight: '100vh',
    width: '100vw',
    zIndex: '1002',
    top: '0',
    left: '0',
    overflowY: 'scroll',
    scrollbarWidth: 'none'
  }

  const rootStyles = {
    height: '100dvh',
    // height: '100vh',
    overflow: 'hidden'
  }
  const closeHandler = () => {
    document.getElementById('modal-root').removeAttribute('style')
    document.getElementById('react').style.removeProperty('height')
    document.getElementById('react').style.removeProperty('overflow')
  }

  useEffect(() => {
    if (isOpen) {
      /* Adding setTimeout as the loyalty enrollment modal is opened before this and close handler 
      in enrollment modal removes the overflow property from root. */
      window.scrollTo(0, 0)
      Object.assign(document.getElementById('react').style, rootStyles)
      setTimeout(() => {
        Object.assign(document.getElementById('modal-root').style, modalRootStyles)
        Object.assign(document.getElementById('react').style, rootStyles)
      }, 2000)
    } else {
      closeHandler()
    }
  }, [isOpen])

  if (!isOpen) return null

  return ReactDOM.createPortal(
    <div
      onClick={() => {
        onClose()
        closeHandler()
      }}
    >
      <ModalOverlay
        onClick={() => {
          onClose()
          closeHandler()
        }}
      />
      <ModalContentWrapper>
        {isShowConfetti ? <Confetti width={window.innerWidth} height={window.innerHeight} /> : null}
        <ModalContent
          $maxWidth={maxWidth}
          $maxWidthMobile={maxWidthMobile}
          $maxHeight={maxHeight}
          $maxHeightMobile={maxHeightMobile}
          onClick={(event) => event.stopPropagation()}
          id='modal-content'
        >
          {!hideCloseIcon && (
            <CloseModalIcon
              onClick={() => {
                onClose()
                closeHandler()
              }}
            >
              <StyledImage />
            </CloseModalIcon>
          )}
          {children}
        </ModalContent>
      </ModalContentWrapper>
    </div>,
    document.getElementById('modal-root')
  )
}

export default GameCompleteModal
